module.exports = __webpack_public_path__ + "media/svg-new/spain-303f1f09.svg";